import { Injectable } from "@angular/core"
import { AppState } from "@store/app-state"
import { Angular2TokenService } from 'angular2-token';
import { Http, Response, URLSearchParams } from '@angular/http'
import { Store } from "@ngrx/store"
import { Observable } from "rxjs/Observable"
import { MatrixClass } from "@models/matrix-class"
import { Contact } from "@models/contact"

export interface ClassIndexParams {
  campusId?: number,
  termId?: number,
  courseId?: number,
  campusIds?: number[],
  termIds?: number[],
  courseIds?: number[],
}

export interface ClassRolloverParams {
  to_term_id: number,
  from_term_id: number,
}

@Injectable()
export class MatrixClassService {

  private classUrl: string = 'classes'
  private teachersUrl: string = 'teachers'

  constructor(
    private http: Angular2TokenService,
    private store: Store<AppState>,
  ) {}

  index(params: ClassIndexParams = {}): Observable<MatrixClass[]> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    for (let key in params) { searchParams.set(key, params[key]) }

    return this.http.get(this.classUrl, options)
      .map((res: Response) => {
        return res.json().map((c: any) => MatrixClass.clone(c))
      })
      .catch((error: Response) => Observable.throw(error.json()))
  }

  fetch(id: number): Observable<MatrixClass> {
    return this.http.get(`${this.classUrl}/${id}`)
      .map((res: Response) => MatrixClass.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  teachers(): Observable<Contact[]> {
    return this.http.get(this.teachersUrl)
      .map((res: Response) => {
        return res.json().map((c: any) => Contact.clone(c))
      })
      .catch((error: Response) => Observable.throw(error.json()))
  }

  create(params: any): Observable<MatrixClass> {
    return this.http.post(this.classUrl, params)
      .map((res: Response) => MatrixClass.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(params: any): Observable<MatrixClass> {
    return this.http.put(`${this.classUrl}/${params.id}`, params)
      .map((res: Response) => MatrixClass.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  rollover(params: ClassRolloverParams): Observable<MatrixClass[]> {
    const url = `${this.classUrl}/rollover/${params.from_term_id}/${params.to_term_id}`

    return this.http.get(url)
      .map((res: Response) => res.json().map((c: any) => MatrixClass.clone(c)))
      .catch((error: Response) => Observable.throw(error.json()))
  }
  
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/matrix-class.ts